import { FC } from 'react';

type Props = {
	className?: string;
};

const CalendarIconSolid: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='#2B2B2B'
			stroke='none'
			className={className}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M5.58719 2C5.99347 2 6.32283 2.32936 6.32283 2.73563V4.20689C6.32283 4.61317 5.99347 4.94253 5.58719 4.94253C5.18092 4.94253 4.85156 4.61317 4.85156 4.20689V2.73563C4.85156 2.32936 5.18092 2 5.58719 2ZM14.4148 2C14.8211 2 15.1504 2.32936 15.1504 2.73563V4.20689C15.1504 4.61317 14.8211 4.94253 14.4148 4.94253C14.0085 4.94253 13.6791 4.61317 13.6791 4.20689V2.73563C13.6791 2.32936 14.0085 2 14.4148 2Z'
				fill='inherit'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M10.7447 2.91943C12.1893 2.91942 13.3341 2.91941 14.2301 3.04965C15.1559 3.18421 15.8957 3.46753 16.4736 4.0923C17.0459 4.71095 17.3002 5.49261 17.4221 6.47217C17.5414 7.43202 17.5414 8.66214 17.5414 10.2317V10.6876C17.5414 12.2572 17.5414 13.4873 17.4221 14.4471C17.3002 15.4267 17.0459 16.2084 16.4736 16.827C15.8957 17.4518 15.1559 17.7351 14.2301 17.8697C13.3341 17.9999 12.1893 17.9999 10.7447 17.9999H9.25758C7.81306 17.9999 6.66825 17.9999 5.77223 17.8697C4.84641 17.7351 4.10665 17.4518 3.52874 16.827C2.95648 16.2084 2.70211 15.4267 2.58029 14.4471C2.46092 13.4873 2.46093 12.2572 2.46094 10.6877V10.2316C2.46093 8.66214 2.46092 7.43202 2.58029 6.47217C2.70211 5.49261 2.95648 4.71095 3.52874 4.0923C4.10665 3.46753 4.84641 3.18421 5.77223 3.04965C6.66824 2.91941 7.81305 2.91942 9.25758 2.91943H10.7447ZM8.23563 10.0918C8.80443 10.0918 9.26553 10.5529 9.26553 11.1217V13.77C9.26553 14.1763 8.93618 14.5056 8.5299 14.5056C8.12362 14.5056 7.79426 14.1763 7.79426 13.77L7.79426 11.5631C7.38798 11.5631 7.05863 11.2338 7.05863 10.8275C7.05863 10.4212 7.38798 10.0918 7.79426 10.0918H8.23563ZM10.0012 10.8275C10.0012 10.4212 10.3305 10.0918 10.7368 10.0918H12.0026C12.5891 10.0918 13.1338 10.6726 12.8861 11.3402L11.8897 14.0259C11.7484 14.4068 11.325 14.601 10.9441 14.4597C10.5632 14.3183 10.369 13.8951 10.5103 13.5141L11.2341 11.5631H10.7368C10.3305 11.5631 10.0012 11.2338 10.0012 10.8275ZM5.58737 6.41368C5.1811 6.41368 4.85174 6.74304 4.85174 7.14931C4.85174 7.5556 5.1811 7.88494 5.58737 7.88494H14.4149C14.8212 7.88494 15.1506 7.5556 15.1506 7.14931C15.1506 6.74304 14.8212 6.41368 14.4149 6.41368H5.58737Z'
				fill='inherit'
			/>
		</svg>
	);
};

export default CalendarIconSolid;
